import UrgentMedicalReport from '@/components/exames/urgent-medical-report/index.vue'
import StatusMixin from '@/shared/mixins/status.mixin'
import AuthMixin from '@/shared/mixins/auth.mixin'
import EmergencyMedicalReportMixin from '@/shared/mixins/emergency-medical-report.mixin'
import ExamMixin from '@/shared/mixins/exam.mixin'
import ExamObservation from '@/shared/mixins/exam-observation.mixin'
import ProtocoloPrintMixin from '@/shared/mixins/protocolo-print.mixin'
import { formatDateTimeBRWithoutSeconds } from '@/shared/utils/date-validator'

import { ref } from 'vue'
export default {
  name: 'exam-details-subheader',
  components: {
    UrgentMedicalReport
  },
  props: {
    details: {
      type: Object,
      required: true
    },
    isFileErrorTab: {
      type: Boolean,
      default: false
    }
  },
  mixins: [
    StatusMixin,
    AuthMixin,
    EmergencyMedicalReportMixin,
    ExamMixin,
    ExamObservation,
    ProtocoloPrintMixin,
  ],
  setup () {
    const isChecked = ref(false)
    return {
      isChecked
    }
  },
  data () {
    return {
      urgent: false,
      showUrgent: false,
      newObservation: null,
      creationDate: null,
      isChecked: false,
      isConfirmed: false,
      isConfirmedOpened: true,
      emergency: false,
      showEmergencySwitch: false,
      modelUrgent: false,
      modelEmergency: false
    }
  },
  watch: {
    'details.examId' () {
      this.syncPriorityState()
    },
    'details.urgent' () {
      this.syncPriorityState()
    },
    'details.emergency' () {
      this.syncPriorityState()
    },
    modelEmergency(newVal) {
      this.$root.$emit('updateModelEmergency', newVal)
    },
    isConfirmedOpened(newVal) {
      this.$root.$emit('updateIsConfirmedOpened', newVal)
    }
  },
  async mounted () {
    this.syncPriorityState()
    const sourceDetails = await this.getSourceDetails()
    this.showEmergencySwitch = sourceDetails.showEmergencySwitch
    this.$root.$emit('updateIsConfirmedOpened', this.isConfirmedOpened)
  },

  computed: {
    hasAddObservation () {
      if (!this.details) {
        return false
      }
    },
    observation () {
      if (!this.details.observations.length) {
        return {}
      }
      const observations = this.details.observations.map(observation => observation)
      this.creationDate = new Date().toISOString()
      return observations
    },
    isEmergency () {
      return this.isEmergencySource()
    },
    isUrgentPriority () {
      return this.urgent || this.isPriorityEnabled(this.details.urgent)
    },
    isEmergencyPriority () {
      return this.isPriorityEnabled(this.details.emergency)
    },
    showEmergency () {
      return this.isEmergencyPriority
    },
    formattedEmergencyAt () {
      if (!this.details.emergencyAt) {
        return ''
      }
      return formatDateTimeBRWithoutSeconds(this.details.emergencyAt).replace(' - ', ' ')
    },
    emergencyRequestedBy () {
      return this.details.emergencyRequestedBy ? String(this.details.emergencyRequestedBy).trim() : ''
    },
    canConfirmEmergency () {
      if (this.details.observations.length > 0) {
        return true
      }

      return !!this.newObservation && this.newObservation.length >= 12
    }
  },
  methods: {
    onUrgentChange () {
      if (this.isPriorityEnabled(this.details.urgent)) {
        this.modelUrgent = true
        this.showUrgent = false
        return
      }

      this.showUrgent = this.modelUrgent
    },
    syncPriorityState () {
      this.modelUrgent = this.isPriorityEnabled(this.details.urgent)
      this.modelEmergency = this.isPriorityEnabled(this.details.emergency)
      this.urgent = this.isPriorityEnabled(this.details.urgent)
      this.emergency = this.isPriorityEnabled(this.details.emergency)
      this.showUrgent = false

      if (this.emergency) {
        this.isChecked = true
        this.isConfirmed = true
        this.isConfirmedOpened = false
        return
      }

      this.isChecked = false
      this.isConfirmed = false
      this.isConfirmedOpened = true
    },
    cancelUrgent () {
      this.urgent = false
      this.showUrgent = false
      this.modelUrgent = false
    },
    confirmUrgent (examId) {
      this.cancelUrgent()
      this.$emit('confirmUrgent', examId)
      this.$set(this.details, 'urgent', true)
      this.modelUrgent = true
      this.syncPriorityState()
    },

    async addObservation () {
      const observation = {
        content: this.newObservation,
        examId: this.details.examId,
        creationDate: new Date().toISOString(),
        nameUser: this.getFullName()
      }

      this.$root.$emit('showLoading')
      try {
        const result = await this.addExamObservation(observation)
        this.details.status.id = result.data.data.status.id
        this.details.status.name = result.data.data.status.name
        const statusId = result.data.data.status.id
        this.details.observations = [observation]
        this.$emit('addObservation', statusId)
      } finally {
        this.$root.$emit('hideLoading')
      }
    },
    async confirmEmergency() {
      try {
        if (this.details.observations.length && Object.keys(this.details.observations).length) {
          this.details.emergency = true
          this.details.emergencyAt = new Date().toISOString()
          this.$root.$emit('showLoading')
          await this.setEmergency(this.details.examId,
            this.details.emergency)
          this.isChecked = true
          this.isConfirmed = true
          this.emergency = true
          this.$emit('submitDetails', this.details)
          this.$root.$emit('refreshFromDetails', this.details)
          this.$root.$emit('hideLoading')
          return
        }

        if ((this.details.observations.length === 0 || !this.details.observations) && (!this.newObservation || this.newObservation.length < 12)) {
          this.$root.$emit('toast', {
            message: 'A observação deve ter no mínimo 12 caracteres.',
            type: 'info'
          })
          return
        }
        this.details.emergency = true
        this.details.emergencyAt = new Date().toISOString()
        this.details.observations = this.newObservation
        this.$root.$emit('showLoading')
        await this.addObservation()
        await this.setEmergency(this.details.examId,
          this.details.emergency)
        this.isChecked = true
        this.isConfirmed = true
        this.emergency = true
        this.$emit('submitDetails', this.details)
        this.$root.$emit('hideLoading')
      } catch (error) {

        this.emergency = this.details.emergency
        this.details.emergencyAt = null
        this.$root.$emit('hideLoading')
      }

      this.$root.$emit('refreshFromDetails', this.details)
      this.isChecked = false
      this.isConfirmed = false
      this.newObservation = ''
      this.isConfirmedOpened = true
    },


    cancelEmergency () {
      this.isChecked = false
      this.isConfirmed = false
      this.isConfirmedOpened = true
      this.modelEmergency = false
      this.modelUrgent = false
      this.newObservation = ''
    },

    sendObservation () {
      this.$emit('sendObservation', this.observation)
    },
    isPriorityEnabled (value) {
      return value === true || value === 1 || String(value).toLowerCase() === 'true' || String(value) === '1'
    }
  }
}
